/*
 * Fragment Block
 * Include content on a page as a fragment.
 * https://www.aem.live/developer/block-collection/fragment
 */

import { loadFragment } from '../../scripts/scripts.js';
import moveInstrumentation from '../../scripts/utils/editor-support-utils.js';
import { isAuthorEnv, isPreviewEnv } from '../../scripts/utils/env-utils.js';

/**
 * @param {Element} block
 */
export default async function decorate(block) {
  const link = block.querySelector('a');
  const path = link ? link.getAttribute('href') : block.textContent.trim();

  if (
    path?.startsWith('/content/sapcom') &&
    !(isAuthorEnv() || isPreviewEnv())
  ) {
    return;
  }

  const fragment = await loadFragment(path);
  if (fragment) {
    fragment.setAttribute('data-activity-map-region', 'body|fragment');
    fragment.querySelectorAll('[data-block-name]').forEach((el) => {
      el.setAttribute(
        'data-activity-map-region',
        `body|${el.getAttribute('data-block-name')}`,
      );
    });
    const fragmentSection = fragment.querySelector(':scope .section');
    if (fragmentSection) {
      block.closest('.section').classList.add(...fragmentSection.classList);
      moveInstrumentation(block, block.parentElement);
      block.closest('.fragment').replaceWith(...fragment.childNodes);
    }
  }
}
